import classNames from 'classnames';
import React from 'react';
import { SvgCheckMark } from './checkmark';
import styles from './pro_comparison_chart.less';
import { OmniaProgramComparisonItem, omniaProgramComparisons } from './pro_page_data';

const ComparisonListItem = ({
  item,
  selectedTier,
}: {
  item: OmniaProgramComparisonItem;
  selectedTier: 'core' | 'pro';
}) => {
  const { text, coreBlurb, proBlurb, tier, freeBlurb } = item;
  const isCashBackRow = text === 'Cash Back Rewards';

  return (
    <React.Fragment key={item.text}>
      <li>
        <span className={styles.item}>
          <span className={styles.itemText}>{text}</span>
        </span>
        <span className={styles.checkContainer}>
          <span className={styles.check}>
            {tier <= 1 && <SvgCheckMark color="#061622" />}
            {freeBlurb && <span className={styles.checkmarkBlurb}>{freeBlurb}</span>}
          </span>
        </span>
        <span
          className={classNames(styles.checkContainer, {
            'bg-[#D9EEF5]': selectedTier === 'core',
          })}
        >
          <span className={styles.check}>
            {isCashBackRow ? (
              <>
                <span className="font-termina font-bold">5%</span>
              </>
            ) : (
              <>
                {tier <= 2 && <SvgCheckMark color="#061622" />}
                {coreBlurb && <span className={styles.checkmarkBlurb}> {coreBlurb}</span>}
              </>
            )}
          </span>
        </span>
        <span
          className={classNames(styles.checkContainer, {
            'bg-[#E8DBAD]': selectedTier === 'pro',
          })}
        >
          <span className={styles.check}>
            {isCashBackRow ? (
              <>
                <span className="font-termina font-bold">10%</span>
              </>
            ) : (
              <>
                {tier <= 3 && <SvgCheckMark color="#061622" />}
                {proBlurb && <span className={styles.checkmarkBlurb}>{proBlurb}</span>}
              </>
            )}
          </span>
        </span>
      </li>
    </React.Fragment>
  );
};

export const ProComparisonChart = ({
  className,
  selectedTier,
}: {
  className?: string;
  selectedTier: 'core' | 'pro';
}) => {
  const tierCoreSelected = selectedTier === 'core';
  const tierProSelected = selectedTier === 'pro';

  return (
    <div className={classNames(styles.comparisonTable, className)}>
      <ul>
        <li className={styles.header}>
          <p className="w-auto flex-1 !text-left font-termina !font-bold">Your Benefits</p>
          <p>Free</p>
          <p
            className={classNames({
              ['bg-[#D9EEF5]']: tierCoreSelected,
            })}
          >
            Core
          </p>
          <p
            className={classNames({
              ['bg-[#E8DBAD]']: tierProSelected,
            })}
          >
            PRO
          </p>
        </li>
        {omniaProgramComparisons.map((item) => (
          <ComparisonListItem key={item.text} item={item} selectedTier={selectedTier} />
        ))}
        <li>
          <span className={styles.item}></span>
          <span className={styles.checkContainer} />
          <span
            className={classNames(styles.checkContainer, 'pb-6 rounded-b-[20px]', {
              'bg-[#D9EEF5]': tierCoreSelected,
            })}
          />
          <span
            className={classNames(styles.checkContainer, 'pb-6 rounded-b-[20px]', {
              'bg-[#E8DBAD]': tierProSelected,
            })}
          />
        </li>
      </ul>
    </div>
  );
};
